module.exports = __webpack_public_path__ + "img/top-image-nomad-african-restaurants-lower-east-side-NYC-Untapped-Cities.5bcd9cc8.jpg";